module.exports = __webpack_public_path__ + "static/media/nm-logo.ad41b189.png";